import { useEffect, useRef } from "react";
import { logWarning } from "web_myplann/Infrastructure/sentry";
import { device } from "web_myplann/Utils/device";

export const useSyncAdvisorsPendingCount = (count?: number) => {
	const lastSentCount = useRef<number | undefined>(undefined);

	useEffect(() => {
		if (count === undefined || count === lastSentCount.current) {
			return;
		}
		lastSentCount.current = count;
		device
			.setAdvisorsPendingCount(count)
			.catch(() => logWarning("Failed to send advisors pending count to app"));
	}, [count]);
};
